// third-party
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";

// project import

// assets
import DashboardOutlined from "@ant-design/icons/DashboardOutlined";
import CatalogIcon from "@ant-design/icons/BookOutlined";
import GoldOutlined from "@ant-design/icons/GoldOutlined";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import MemberIcon from "@ant-design/icons/UserOutlined";
import MasterIcon from "@ant-design/icons/DatabaseOutlined";
import InstituteIcon from "@ant-design/icons/BankOutlined";
import MaterialIcon from "@ant-design/icons/ReadOutlined";
import PurchaseIcon from "@ant-design/icons/CreditCardOutlined";
import CircularIcon from "@ant-design/icons/QrcodeOutlined";
import GroupCirculationIcon from "@ant-design/icons/UsergroupAddOutlined";
import StockVerificationIcon from "@ant-design/icons/FileSearchOutlined";
import SecurityScanOutlined from "@ant-design/icons/SecurityScanOutlined";
import FeeIcon from "@ant-design/icons/WalletOutlined";
import CloudDownloadOutlined from "@ant-design/icons/CloudDownloadOutlined";
import SettingOutlined from "@ant-design/icons/SettingOutlined";
import ContainerOutlined from "@ant-design/icons/ContainerOutlined";
import BarcodeOutlined from "@ant-design/icons/lib/icons/BarcodeOutlined";
import MailOutlined from "@ant-design/icons/MailOutlined";
import FundOutlined from "@ant-design/icons/FundOutlined";

// type
import { NavItemType } from "types/menu";

import { useGetMenu } from "api/menu";

const icons = {
  dashboard: DashboardOutlined,
  catalog: CatalogIcon,
  circular: CircularIcon,
  groupCirculation: GroupCirculationIcon,
  stockVerification: StockVerificationIcon,
  fee: FeeIcon,
  member: MemberIcon,
  institute: InstituteIcon,
  master: MasterIcon,
  material: MaterialIcon,
  purchase: PurchaseIcon,
  components: GoldOutlined,
  loading: LoadingOutlined,
  security: SecurityScanOutlined,
  reports: CloudDownloadOutlined,
  settings: SettingOutlined,
  receipt: ContainerOutlined,
  barCode: BarcodeOutlined,
  budget: FundOutlined,
  notification: MailOutlined,
  biometric: SecurityScanOutlined,
  biometricConfiguration: SecurityScanOutlined,
};

const loadingMenu: NavItemType = {
  id: "group-dashboard-loading",
  title: <FormattedMessage id="dashboard" />,
  type: "group",
  icon: icons.loading,
  children: [
    {
      id: "dashboard1",
      title: <FormattedMessage id="dashboard" />,
      type: "collapse",
      icon: icons.loading,
      children: [
        {
          id: "default1",
          title: "loading",
          type: "item",
          url: "/dashboard/default",
          breadcrumbs: false,
        },
        {
          id: "analytics1",
          title: "loading",
          type: "item",
          url: "/dashboard/analytics",
          breadcrumbs: false,
        },
      ],
    },
  ],
};

// ==============================|| MENU ITEMS - API ||============================== //

export function MenuFromAPI() {
  const { menu, menuLoading } = useGetMenu();

  return useMemo(() => {
    if (menuLoading || !menu) return loadingMenu;

    const subChildrenList = (children: NavItemType[]) => {
      return children?.map((subList: NavItemType) => {
        return fillItem(subList);
      });
    };

    const itemList = (subList: NavItemType) => {
      const list = fillItem(subList);

      // if collapsible item, we need to feel its children as well
      if (subList.type === "collapse") {
        list.children = subChildrenList(subList.children!);
      }
      return list;
    };

    const childrenList: NavItemType[] | undefined = menu?.children?.map(
      (subList: NavItemType) => {
        return itemList(subList);
      }
    );

    const menuList = fillItem(menu, childrenList);
    return menuList;
  }, [menu, menuLoading]);
}

function fillItem(item: NavItemType, children?: NavItemType[] | undefined) {
  return {
    ...item,
    title: <FormattedMessage id={`${item?.title}`} />,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    icon: icons[item?.icon],
    ...(children && { children }),
  };
}
